// extracted by mini-css-extract-plugin
export default {"tax-label":"O6c7zwd","tax-label__color":"XNxKxJu"};